import React, {useState} from 'react';
import { AutoCompleteSelect } from './auto-complete-select';
import { SelectedItemWidget } from './selected-item-widget';

const AutoCompleteWidgetChoose = ({selectedTemplate, autoComplete, selectedItem, onSelect}) => {
    
    if(!selectedItem){ 
        return autoComplete;
    } else {
        return <SelectedItemWidget onSelect={onSelect}>{selectedTemplate}</SelectedItemWidget>
    }
}


export { AutoCompleteWidgetChoose }